export const pickupsSelector = state => state.checkout.deliveryOptions;
